module.exports = __webpack_public_path__ + "assets/189f6ab0db06f23ad8f4632478724a6e.mp3";